var ImageResizeOptions = /* @__PURE__ */ ((ImageResizeOptions2) => {
  ImageResizeOptions2["crop"] = "CROP";
  ImageResizeOptions2["fit"] = "FIT";
  return ImageResizeOptions2;
})(ImageResizeOptions || {});
export {
  ImageResizeOptions
};
//# sourceMappingURL=types.js.map
